module.exports = __webpack_public_path__ + "img/joel-headshot.f0653f6a.png";